import Vue from 'vue'
import App from './App'
import Router from './router'

import VueResource from 'vue-resource'
import Auth from './packages/auth/Auth.js'
import Lang from './packages/lang/Lang.js'
import VeeValidate from 'vee-validate'
import Pusher from 'pusher-js'
import VueI18n from 'vue-i18n'
import en from './packages/lang/languages/en'
import es from './packages/lang/languages/es'
import de from './packages/lang/languages/de'
import * as VueGoogleMaps from 'vue2-google-maps'
import Datetime from 'vue-datetime'

import VueSignaturePad from 'vue-signature-pad'
Vue.use(VueSignaturePad)

import VueEvents from 'vue-events'
Vue.use(VueEvents)

import VueCurrencyFilter from 'vue-currency-filter'
Vue.use(VueCurrencyFilter)

import VueQriously from 'vue-qriously'
Vue.use(VueQriously)

// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import VueQuillEditor from 'vue-quill-editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

//-- Notifications
import Notifications from 'vue-notification'
Vue.use(Notifications)

import '@riophae/vue-treeselect/dist/vue-treeselect.css'

Vue.use(VueQuillEditor, {
	theme: 'snow',
})

Vue.use(Datetime)
Vue.use(VueResource)
Vue.use(Auth)
Vue.use(Lang)

Vue.use(VueGoogleMaps, {
	installComponents: true,
	load: {
		key: process.env.GOOGLE_MAPS_KEY,
		libraries: ['places', 'geometry'],
	}
})

//-- Config VueI18n to language
var locale = window.navigator.language || navigator.browserLanguage;
if(locale.length > 2) {
	locale = locale.slice(0, -3)
}
const locales = ['es', 'en', 'de']
Vue.use(VueI18n)
export const i18n = new VueI18n({
	messages: {
		en: en,
		es: es,
		de: de,
	}
})

Vue.use(VeeValidate, {
	fieldsBagName: 'formFields'
})

//-- config file
Vue.env = process.env
Object.defineProperties(Vue.prototype, {
	$env: {
		get () {
			return Vue.env;
		}
	}
})

//-- VueResource configuration
Vue.http.options.root = process.env.ROOT + '/api/' + Vue.lang.getLang() + '/'
Vue.http.headers.common['Authorization'] = 'Bearer ' + Vue.auth.getToken()

import axios from 'axios'

// Creation of pucher object and added as an attribute of the Vue object
var pusher = new Pusher(process.env.PUSHER_KEY, {
	authEndpoint: process.env.ROOT + 'api/auth_endpoint',
	cluster: 'eu',
	encrypted: true,
	auth: {
		headers: {
			'Accept': 'application/json',
			'Authorization': 'Bearer ' + Vue.auth.getToken(),
		}
	},
})
Vue.pusher = pusher
Object.defineProperties(Vue.prototype, {
	$pusher: {
		get () {
			return Vue.pusher;
		}
	}
})

//-- Navigation Guards
Router.beforeEach(
	(to, from, next) => {
		window.scrollTo(0, 0)
		let language = to.params.lang
		let account = to.params.account

		if(typeof(language) === 'undefined') {
			language = Vue.lang.getLang()
			if(typeof(language) === 'undefined') {
				language = locale
			}
			next({
				path: '/' + language
			})
		} else {
			let inside = locales.find(function(locale) {
				return locale === language
			})

			if(!inside) {
				language = locale
				next({
					path: '/' + language
				})
			}
		}

		Vue.lang.setLang(language)
		i18n.locale = language

		if(to.meta.title) {
			document.title = to.meta.title
		}

		if(!to.matched.length) {
			console.log('No matched! redirect...')
			if(typeof(account) === 'undefined') {
				next({
					path: '/' + language
				})
			} else {
				next({
					path: '/' + language + '/' + account + '/admin'
				})
			}
		}

		if(to.matched.some(record => record.meta.forVisitors)) {
			if(Vue.auth.isAuthenticated()) {
				if(Vue.auth.getAccount()) {
					next({
						path: '/' + language + '/' + Vue.auth.getAccount() + '/admin'
					})
				} else {
					if(typeof(account) === 'undefined') {
						next({
							path: '/' + language
						})
					} else {
						next({
							path: '/' + language + '/' + account
						})
					}
				}
			} else {
				next()
			}
		} else if(to.matched.some(record => record.meta.forAuth)) {
			if(!Vue.auth.isAuthenticated()) {
				if(typeof(account) === 'undefined') {
					next({
						path: '/' + language,
						query: {
							from: to.fullPath
						}
					})
				} else {
					next({
						path: '/' + language + '/' + account,
						query: {
							from: to.fullPath
						}
					})
				}
			} else {
				next()
			}
		} else {
			next()
		}
	}
)

//-- DIRECTIVE
Vue.directive("trim", {
	inserted: function(el) {
		var str = el.innerHTML;
		var resultString = str.split(' ').slice(0, 5).join(" ") + "...";
		el.innerHTML = resultString
	}
})

//-- FILTERS
	/*
	Vue.filter('currency', function(value, currency) {
		if(value) {
			if(currency) {
				return value + ' ' + currency.symbol
			}
			return value
		}
	})*/

	Vue.filter('comma', function(value) {
		if(value) {
			return value.replace(".", ",")
		}
	})

	Vue.filter('trucate', function(value, length) {
		return value.substring(0, length) + '...'
	})

	Vue.filter('ucfirst', function(value) {
		return value.charAt(0).toUpperCase() + value.slice(1)
	})

	Vue.filter('formattedPlace', function(value, number = 1) {
		var formatted = null
		if(number == 1) {
			if(value.google_place_id) {
				if(value.route) {
					formatted = value.route
				}
				if(value.street_number) {
					if(formatted) {
						formatted += ', ' + value.street_number
					} else {
						formatted = value.street_number
					}
				}
				if(value.postal_code) {
					if(formatted) {
						formatted += ', ' + value.postal_code
					} else {
						formatted = value.postal_code
					}
				}
			} else {
				if(value.formatted_address) {
					formatted = value.formatted_address
				}
				if(value.postal_code) {
					if(formatted) {
						formatted += ', ' + value.postal_code
					} else {
						formatted = value.postal_code
					}
				}
			}
		} else {
			if(number == 2) {
				if(value.locality) {
					formatted = value.locality
				}
				if(value.administrative_area_level_2) {
					if(formatted) {
						formatted += ', ' + value.administrative_area_level_2
					} else {
						formatted = value.administrative_area_level_2
					}
				}
			}
		}
		return formatted;
	})

	//-- Slugify
	var slugify = require('slugify')

	Vue.filter('slugify', function(value) {
		if(value) {
			return slugify(value, {
				remove: '\.',
				lower: true
			})
		} else {
			return ''
		}
	})

	//-- Moment
	Vue.filter('moment', function(value, display_time = true) {
		if(display_time) {
			var time = ' H:mm'
		} else {
			var time = ''
		}
		return moment(value).format('DD/MM/YY' + time);
	})

	Vue.filter('fromNow', function(value) {
		return moment(value).fromNow()
	})

	Vue.filter('humanizeSeconds', function(value) {
		var duration = moment.duration(value, 'seconds')
		var hours = parseInt(duration.asHours())
		var minutes = parseInt(duration.get('minutes'))
		var negative = false

		if(minutes < 0) {
			negative = true
		}

		if(hours < 0) {
			negative = true
		}

		minutes = Math.abs(minutes)
		hours = Math.abs(hours)

		var minutesString = minutes.toString()
		if(minutesString.length == 1) {
			minutes = '0' + minutes
		}

		var hoursString = hours.toString()
		if(hoursString.length == 1) {
			hours = '0' + hours
		}

		if(negative) {
			return '-' + hours + ':' + minutes
		} else {
			return hours + ':' + minutes
		}
	})

	Vue.filter('checkDecimals', function(value) {
		if(value) {
			var val = value
			var number = 2
			var sentence1 = "^(\\d+[\\.\\,]?\\d{0,!!!})$"
			var regx1 = new RegExp(sentence1.replace('!!!', number))
			var sentence2 = "^(\\d+[\\.\\,]?\\d{0,!!!})"
			var regx2 = new RegExp(sentence2.replace('!!!', number))

			if (!regx1.test(val)) {
				val = regx2.exec(val)
				if(val) {
					return val[0]
				}
			}
		}
		return value
	})

Vue.config.productionTip = false

//-- function to create Vue instance
function createVue() {
	new Vue({
		el: '#app',
		router: Router,
		template: '<App/>',
		components: { App },
		i18n,
		watch: {
			'$i18n.locale': function (locale) {
				Vue.lang.setLang(locale)
				this.$router.replace({
					params: {
						lang: locale
					},
				})
				Vue.http.options.root = process.env.ROOT + '/api/' + Vue.lang.getLang() + '/'
			}
		},
	})
}



function getPlatform (callback = null) {
	Vue.http.get(process.env.ROOT + '/api/' + Vue.lang.getLang() + '/platform')
	.then(response => {
		var platform = response.body
		var hasPackage = function hasPackage(id, requireAll = false) {
			if(platform) {
				if(platform.accounts) {
					var accounts = platform.accounts.filter(function(account) {
						if(Array.isArray(id)) {
							if(account.package) {
								return id.find(function(package_id) {
									if(account.id == package_id) return true
								})
							}
						} else {
							if(account.package) {
								if(account.package.id == id) return true
							}
						}
					})

					if(Array.isArray(id)) {
						if(requireAll) {
							if(accounts.length != id.length) {
								return false
							}
						}
					}

					if(accounts.length) return true
				}
			}
			return false
		}

		platform['hasPackage'] = hasPackage
		Object.defineProperties(Vue.prototype, {
			$platform: {
				get () {
					return platform;
				},
				set(value) {
					platform = value
				}
			}
		})

		axios.interceptors.request.use(function (config) {
			config.headers.common['Authorization'] = 'Bearer ' + Vue.auth.getToken()
			config.headers.common['account'] = platform.slug
			return config
		}, function (error) {
			console.log(error)
			return Promise.reject(error)
		})
		
		if(callback) {
			callback()
		}
	}, function(error) {
		console.log(error)
		//window.location.href = "/" + locale;
	})
}

function setAccountHeader (callback) {
	var pathArray = window.location.pathname.split('/')
	var account = pathArray[2]

	if(!account) {
		var account = Vue.auth.getAccount()
	}
	
	if(account) {
		Vue.http.headers.common['account'] = account
		getPlatform(callback)
	} else {
		createVue()
	}

}

//-- function to init app
function init(Vue, callback) {
	if(Vue.lang.getLang()) {
		//getPlatform(callback)
		setAccountHeader(callback)
	} else {
		Vue.lang.setLang(locale)
		i18n.locale = locale
		setAccountHeader(callback)
	}
}

init(Vue, createVue)


// WEBPACK FOOTER //
// ./src/main.js